import { PropsWithChildren } from "react";
import classes from "./Backdrop.module.scss";
import { useBodyLock } from "@/common/hooks/useBodyLock";

interface BackdropProps extends PropsWithChildren {
  isAgeVerification?: boolean;
  isBlur?: boolean;
}

export const Backdrop = ({ children, isBlur }: BackdropProps) => {
  useBodyLock(true);

  return (
    <div className={`${classes.Backdrop} ${isBlur ? classes.Blurred : ""}`}>
      {children}
    </div>
  );
};
